// extracted by mini-css-extract-plugin
module.exports = {"keepToggleOnButton":"KeepScreenOnToggle_keepToggleOnButton__GAuck","toggleIcon":"KeepScreenOnToggle_toggleIcon__cV8eo","checked":"KeepScreenOnToggle_checked__3VQ2d"};